import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Toast } from 'ngx-toastr';

const TOAST_ICONS: Record<string, string> = {
  'toast-success': 'check_circle',
  'toast-error': 'error',
  'toast-warning': 'warning',
  'toast-info': 'info',
};

@Component({
  selector: '[toast-component]',
  standalone: true,
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent extends Toast {
  protected readonly icon = TOAST_ICONS[this.toastPackage.toastType] ?? 'info';
}
